module.exports = __webpack_public_path__ + "img/floral-one.e9dc1539.svg";